export const products = {
  basic: "price_1OaBifKxip6eEAzhro5YrQOh",
  premium: "price_1OaBjpKxip6eEAzhtKFy3hSi",
};
